import React from 'react';
import { usePlanningBottomupState } from '../Context/index';

export function UnitCostRetail() {
  const { planningBottomup, checkVisibleBottomUp } = usePlanningBottomupState();
  const { planningBottomProducts, selectedDisplayColumn } = planningBottomup;
  const unitCostRetailFeilds = [
    // {
    //   keyName: "unitsRetail",
    //   name: "Units Retail",
    // },
    // {
    //   keyName: "costRetail",
    //   name: "Cost Retail",
    // },
  ];

  // Early return for empty fields to avoid SonarJS warnings
  if (unitCostRetailFeilds.length === 0) {
    return null;
  }

  const isTableVisible = unitCostRetailFeilds?.filter((ele) => selectedDisplayColumn?.includes(ele.keyName));
  return (
    isTableVisible.length > 0 && (
      <table className="table custom-table layout-fixed planning-actual-tbl font-13 mr-3">
        <thead>
          <tr>
            {unitCostRetailFeilds?.map((unitCostItem, i) => {
              const isVisible = checkVisibleBottomUp(unitCostItem.keyName);
              return (
                isVisible && (
                  <th key={i} className="w-200px">
                    <span>{unitCostItem?.name}</span>
                  </th>
                )
              );
            })}
          </tr>
        </thead>
        <tbody>
          {(planningBottomProducts ?? [])?.map((trItem, iParent) => {
            return (
              <tr key={iParent}>
                {unitCostRetailFeilds?.map((tdItem, iTD) => {
                  const isVisible = checkVisibleBottomUp(tdItem.keyName);
                  return (
                    isVisible && (
                      <td key={iTD} className="text-right">
                        {trItem[tdItem?.keyName]}
                      </td>
                    )
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    )
  );
}
export default UnitCostRetail;
